module.exports = __webpack_public_path__ + "static/RemoteIcon-0798599754d7470e2677340b91a52257.png";